import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as seasonActions from '../../actions/seasons';
import Select from '../form/select';
import LocalizedStrings from '../../localization/strings';

class SeasonSelection extends Component {

    componentDidMount() {
        this.props.actions.fetchAllSeasons();
    }

    render() {
        const {field} = this.props;
        return (<Select clearable={false} options={this.props.seasons.items} noResultsText={LocalizedStrings.noSeasons}
                        placeholder={LocalizedStrings.season} {...field}  onChange={(item)=>field.onChange(item.value)}/>)
    }
}

export default connect(function (state) {
    return {seasons: state.season.availableSeasons}
}, function (dispatch) {
    return {
        actions: bindActionCreators(seasonActions, dispatch)
    }
})(SeasonSelection);



// WEBPACK FOOTER //
// ./src/js/components/season/season-select.js